import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../../common/components/loader";
import DashboardLayout from "../../../common/layouts/dashboard";
import { useAppDispatch } from "../../../core/hooks/useStore";
import { RootState } from "../../../core/store/store";
import { homeSlice } from "../../home";
import { HeadlinePigCreateDialog } from "./headline-pig-create-dialog";
import HeadlinePigDesc from "./headline-pig-desc";
import HeadlinePigHeader from "./headline-pig-header";
import HeadlinePigLoading from "./headline-pig-loading";
import HeadlinePigLocked from "./headline-pig-locked";
// Removed nav bar import - functionality moved to header
import toolsSlice from "./headline-pig.slice";
import HeadlinePigResults from "./results/results";
import useTool from "./use-headline-pig";

const HeadlinePig = () => {
  const dispatch = useAppDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const toolsState = useSelector((state: RootState) => state.headlinePig);
  const navigate = useNavigate();
  const { resultId } = useParams<{ resultId?: string }>();
  const hasAccess = auth.tools?.headlineTool;

  useEffect(() => {
    dispatch(homeSlice.actions.setActiveMenu("headline-tool"));
    dispatch(toolsSlice.actions.setType("HEADLINE"));
    if (hasAccess) {
      // If we have a resultId in the URL, load that specific result
      if (resultId) {
        // Load the specific result
        loadResultById(resultId);
      } else {
        dispatch(toolsSlice.actions.setStatus("initialized"));
      }
    } else {
      navigate("/tools");
    }
  }, [homeSlice, resultId]);

  const tool = useTool();

  const loadResultById = async (id: string) => {
    try {
      dispatch(toolsSlice.actions.setStatus("loading"));
      const result = await tool.getJob(id);
      if (result && result.finishedAt) {
        dispatch(toolsSlice.actions.setData(result));
        dispatch(toolsSlice.actions.setStatus("created"));
      } else {
        dispatch(toolsSlice.actions.setStatus("initialized"));
        navigate("/tools/headline-tool");
      }
    } catch (error) {
      console.error("Failed to load result:", error);
      dispatch(toolsSlice.actions.setStatus("initialized"));
      navigate("/tools/headline-tool");
    }
  };
  const [loading, setLoading] = useState(true);

  const HeadlinePigLoader = () => {
    return <Loader />;
  };

  const handleOpen = () => {
    dispatch(toolsSlice.actions.setCreateDialogOpened(true));
  };

  const handleClose = () => {
    dispatch(toolsSlice.actions.setCreateDialogOpened(false));
  };

  return (
    <DashboardLayout active={"headline-pig"} name="Headline Pig">
      <Box>
        {toolsState.tool.status === "loading" && <HeadlinePigLoader />}
        {toolsState.tool.status === "initialized" && (
          <>
            <HeadlinePigHeader />
            <HeadlinePigDesc />
            <HeadlinePigCreateDialog
              onClose={handleClose}
              open={toolsState.tool.createDialogOpened}
              defaultNiche={toolsState.tool.defaultSearch}
            />
          </>
        )}
        {toolsState.tool.status === "unauthorized" && <HeadlinePigLocked />}
        {/* Show when query is in progress */}
        {toolsState.tool.status === "creating" && (
          <>
            <HeadlinePigHeader />
            <HeadlinePigLoading />
          </>
        )}
        {toolsState.tool.status === "created" && (
          <>
            <HeadlinePigHeader />
            <HeadlinePigResults />
          </>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default HeadlinePig;
